import React from 'react';
import { Facebook, Instagram } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-brand-dark text-white pt-16 pb-8" data-id="element-91">
      <div className="container mx-auto px-6 md:px-8" data-id="element-92">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16 text-center md:text-left" data-id="element-93">
          {/* Col 1: Brand */}
          <div className="flex flex-col items-center md:items-start" data-id="element-94">
            <Logo variant="light" className="mb-4" data-id="element-95" />
            <p className="text-brand-amber font-medium mb-6" data-id="element-96">
              Clean. Balanced. Swim Ready.
            </p>
            <div className="flex items-center gap-4" data-id="element-97">
              <a href="#" className="text-white/60 hover:text-white transition-colors" aria-label="Facebook" data-id="element-98">
                <Facebook size={20} data-id="element-99" />
              </a>
              <a href="#" className="text-white/60 hover:text-white transition-colors" aria-label="Instagram" data-id="element-100">
                <Instagram size={20} data-id="element-101" />
              </a>
            </div>
          </div>

          {/* Col 2: Navigation */}
          <div className="flex flex-col items-center md:items-start" data-id="element-102">
            <h4 className="font-heading font-bold text-lg mb-6" data-id="element-103">Navigation</h4>
            <ul className="space-y-3" data-id="element-104">
              <li data-id="element-105">
                <a href="#" className="text-white/70 hover:text-white transition-colors" data-id="element-106">
                  Home
                </a>
              </li>
              <li data-id="element-107">
                <a href="#about" className="text-white/70 hover:text-white transition-colors" data-id="element-108">
                  About Us
                </a>
              </li>
              <li data-id="element-109">
                <a href="#services" className="text-white/70 hover:text-white transition-colors" data-id="element-110">
                  Services
                </a>
              </li>
              <li data-id="element-111">
                <a href="#faq" className="text-white/70 hover:text-white transition-colors" data-id="element-112">
                  FAQ
                </a>
              </li>
              <li data-id="element-113">
                <a href="#contact" className="text-white/70 hover:text-white transition-colors" data-id="element-114">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Col 3: Contact */}
          <div className="flex flex-col items-center md:items-start" data-id="element-115">
            <h4 className="font-heading font-bold text-lg mb-6" data-id="element-116">
              Contact Info
            </h4>
            <ul className="space-y-3 text-white/70" data-id="element-117">
              <li data-id="element-118">
                <a href="tel:+16015550123" className="hover:text-white transition-colors" data-id="element-119">
                  (601) 555-0123
                </a>
              </li>
              <li data-id="element-120">
                <a href="mailto:service@royalpoolcleaning.com" className="hover:text-white transition-colors" data-id="element-121">
                  service@royalpoolcleaning.com
                </a>
              </li>
              <li className="pt-2" data-id="element-122">Madison, MS</li>
              <li data-id="element-123">Madison County</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/50 text-center md:text-left" data-id="element-124">
          <p data-id="element-125">© 2025 Royal Pool Cleaning. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}